import React, { useEffect, useState } from 'react';
import api from '@api';
import './PlayerTeamSeasonStats.css'

const PlayerTeamSeasonStats = ({ playerId, slug, domain }) => {
 const [gameStats, setGameStats] = useState([]);
 const [allStats, setAllStats] = useState([]);
 const [expandedSeasonId, setExpandedSeasonId] = useState(null);


 useEffect(() => {
  const fetchStats = async () => {
   try {
    const res = await api.get(`/api/playersv2/${playerId}/stats`, {
     params: slug ? { slug } : { domain },
    });

    setGameStats(res.data.gameStats || []);
    setAllStats(res.data.allStats || []);
   } catch (err) {
    console.error("Failed to fetch player stats", err);
   }
  };

  if (playerId) fetchStats();
 }, [playerId, slug, domain]);
 console.log("📊 allStats:", allStats.map(s => s.abbreviation));
 console.log("🧩 gameStats stats seen:", [
  ...new Set(gameStats.map(g => g.stat?.abbreviation)),
 ]);

 // if (!gameStats.length || !allStats.length) return null;

 const groupedSeasonStats = {};
 gameStats.forEach((gs) => {
  const season = gs.game?.seasons_league?.season?.name || "Unknown Season";
  let team = "Unknown";
  if (Number(gs.team_id) === Number(gs.game?.home_team?.team?.id)) {
   team = gs.game.home_team.team.name;
  } else if (Number(gs.team_id) === Number(gs.game?.away_team?.team?.id)) {
   team = gs.game.away_team.team.name;
  }

  const key = season; // Just group by season for dropdown

  if (!groupedSeasonStats[key]) {
   groupedSeasonStats[key] = {
    season,
    gameIds: new Set(),
    statsMap: {},
    gameStats: [], // 🔥 Store raw stats for that season
   };
  }

  groupedSeasonStats[key].gameIds.add(gs.game_id);
  groupedSeasonStats[key].gameStats.push(gs); // 🔥 Keep raw entries
  const abbr = gs.stat?.abbreviation;
  if (abbr) {
   groupedSeasonStats[key].statsMap[abbr] =
    (groupedSeasonStats[key].statsMap[abbr] || 0) + Number(gs.value);
  }
 });

 const statTableRows = Object.values(groupedSeasonStats).map((entry) => ({
  season: entry.season,
  team: entry.team,
  gamesPlayed: entry.gameIds.size,
  stats: allStats.map((s) => ({
   abbreviation: s.abbreviation,
   value: entry.statsMap[s.abbreviation] || 0,
  })),
 }));





 return (
  <div className="team-season-stats">
   <h3 className="season-summary-title">Season Breakdown</h3>
   <div className="individual-player-public-stats-table-container">
    <table className="individual-player-public-stats-table">
     <thead>
      <tr>
       <th>Season</th>
       <th>GP</th>
       {allStats
        .filter(stat => stat.abbreviation !== "FT%")
        .map((stat) => (
         <th key={stat.id}>{stat.abbreviation}</th>
        ))}
       {/* ✅ Manually add calculated FT% header */}
       {(allStats.some(s => s.abbreviation === "FTM") && allStats.some(s => s.abbreviation === "FTA")) && (
        <th>FT%</th>
       )}
      </tr>
     </thead>


     <tbody>
      {statTableRows.map((row, i) => {
       const seasonKey = `${row.season}-${row.team}`;
       const isExpanded = expandedSeasonId === seasonKey;

       return (
        <React.Fragment key={i}>
         <tr
          className="clickable-row"
          onClick={() =>
           setExpandedSeasonId(isExpanded ? null : seasonKey)
          }
         >
          <td>{row.season}</td>
          <td>{row.gamesPlayed}</td>
          {row.stats
           .filter(stat => stat.abbreviation !== "FT%") // ✅ filter raw FT%
           .map((stat, idx) => (
            <td key={idx}>{stat.value}</td>
           ))}

          {row.stats.some(s => s.abbreviation === "FTM") &&
           row.stats.some(s => s.abbreviation === "FTA") && (
            <td>
             {(() => {
              const ftm = row.stats.find(s => s.abbreviation === "FTM")?.value || 0;
              const fta = row.stats.find(s => s.abbreviation === "FTA")?.value || 0;
              return fta ? ((ftm / fta) * 100).toFixed(1) + "%" : "0.0%";
             })()}
            </td>
           )}


         </tr>

         {isExpanded && (
          <tr>
           <td colSpan={3 + row.stats.length}>
            <div className="expand-container">
             <div className="expanded-table-wrapper">
              <table className="individual-player-expanded-table">
               <thead>
                <tr>
                 <th>Date</th>
                 <th>Matchup</th>
                 {allStats
                  .filter((stat) => stat.abbreviation !== "FT%")
                  .map((stat) => (
                   <th key={stat.id}>{stat.abbreviation}</th>
                  ))}
                 {gameStats.some((gs) => gs.stat?.abbreviation === "FTM") &&
                  gameStats.some((gs) => gs.stat?.abbreviation === "FTA") && (
                   <th>FT%</th>
                  )}
                </tr>
               </thead>


               <tbody>
                {Array.from(
                 new Map(
                  groupedSeasonStats[row.season]?.gameStats.map((gs) => [gs.game_id, gs.game])
                 ).values()
                )
                 .sort((a, b) => new Date(b.date || b.game_dateTime) - new Date(a.date || a.game_dateTime)) // ✅ sort by date DESC
                 .map((game, index) => (
                  <tr key={index}>
                   <td>{new Date(game.date || game.game_dateTime).toLocaleDateString()}</td>
                   <td>{game.home_team?.team?.name} vs {game.away_team?.team?.name}</td>
                   {allStats
                    .filter((stat) => stat.abbreviation !== "FT%") // hide raw FT%
                    .map((stat, idx) => {
                     const matchingStat = groupedSeasonStats[row.season].gameStats.find(
                      (entry) =>
                       entry.game_id === game.id &&
                       entry.stat?.abbreviation === stat.abbreviation
                     );
                     return <td key={idx}>{matchingStat ? matchingStat.value : 0}</td>;
                    })}


                   {allStats.some((s) => s.abbreviation === "FTM") &&
                    allStats.some((s) => s.abbreviation === "FTA") && (
                     <td>
                      {(() => {
                       const ftm = groupedSeasonStats[row.season].gameStats.find(
                        (entry) =>
                         entry.game_id === game.id &&
                         entry.stat?.abbreviation === "FTM"
                       )?.value || 0;
                       const fta = groupedSeasonStats[row.season].gameStats.find(
                        (entry) =>
                         entry.game_id === game.id &&
                         entry.stat?.abbreviation === "FTA"
                       )?.value || 0;
                       return fta ? ((ftm / fta) * 100).toFixed(1) + "%" : "0.0%";
                      })()}
                     </td>
                    )}

                  </tr>
                 ))}



               </tbody>
              </table>
             </div>
            </div>
           </td>
          </tr>
         )}
        </React.Fragment>
       );
      })}
     </tbody>


    </table>
   </div>
  </div>
 );
};

export default PlayerTeamSeasonStats;
